"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Calendar = _interopRequireDefault(require("../Calendar"));
var _DayCell = require("../DayCell");
var _utils = require("../../utils");
var _dateFns = require("date-fns");
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = _interopRequireDefault(require("../../styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class DateRange extends _react.Component {
  constructor(props, context) {
    var _this;
    super(props, context);
    _this = this;
    _defineProperty(this, "calcNewSelection", function (value) {
      let isSingleValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      const focusedRange = _this.props.focusedRange || _this.state.focusedRange;
      const {
        ranges,
        onChange,
        maxDate,
        moveRangeOnFirstSelection,
        retainEndDateOnFirstSelection,
        disabledDates
      } = _this.props;
      const focusedRangeIndex = focusedRange[0];
      const selectedRange = ranges[focusedRangeIndex];
      if (!selectedRange || !onChange) return {};
      let {
        startDate,
        endDate
      } = selectedRange;
      const now = new Date();
      let nextFocusRange;
      if (!isSingleValue) {
        startDate = value.startDate;
        endDate = value.endDate;
      } else if (focusedRange[1] === 0) {
        // startDate selection
        const dayOffset = (0, _dateFns.differenceInCalendarDays)(endDate || now, startDate);
        const calculateEndDate = () => {
          if (moveRangeOnFirstSelection) {
            return (0, _dateFns.addDays)(value, dayOffset);
          }
          if (retainEndDateOnFirstSelection) {
            if (!endDate || (0, _dateFns.isBefore)(value, endDate)) {
              return endDate;
            }
            return value;
          }
          return value || now;
        };
        startDate = value;
        endDate = calculateEndDate();
        if (maxDate) endDate = (0, _dateFns.min)([endDate, maxDate]);
        nextFocusRange = [focusedRange[0], 1];
      } else {
        endDate = value;
      }

      // reverse dates if startDate before endDate
      let isStartDateSelected = focusedRange[1] === 0;
      if ((0, _dateFns.isBefore)(endDate, startDate)) {
        isStartDateSelected = !isStartDateSelected;
        [startDate, endDate] = [endDate, startDate];
      }
      const inValidDatesWithinRange = disabledDates.filter(disabledDate => (0, _dateFns.isWithinInterval)(disabledDate, {
        start: startDate,
        end: endDate
      }));
      if (inValidDatesWithinRange.length > 0) {
        if (isStartDateSelected) {
          startDate = (0, _dateFns.addDays)((0, _dateFns.max)(inValidDatesWithinRange), 1);
        } else {
          endDate = (0, _dateFns.addDays)((0, _dateFns.min)(inValidDatesWithinRange), -1);
        }
      }
      if (!nextFocusRange) {
        const nextFocusRangeIndex = (0, _utils.findNextRangeIndex)(_this.props.ranges, focusedRange[0]);
        nextFocusRange = [nextFocusRangeIndex, 0];
      }
      return {
        wasValid: !(inValidDatesWithinRange.length > 0),
        range: {
          startDate,
          endDate
        },
        nextFocusRange: nextFocusRange
      };
    });
    _defineProperty(this, "setSelection", (value, isSingleValue) => {
      const {
        onChange,
        ranges,
        onRangeFocusChange
      } = this.props;
      const focusedRange = this.props.focusedRange || this.state.focusedRange;
      const focusedRangeIndex = focusedRange[0];
      const selectedRange = ranges[focusedRangeIndex];
      if (!selectedRange) return;
      const newSelection = this.calcNewSelection(value, isSingleValue);
      onChange({
        [selectedRange.key || `range${focusedRangeIndex + 1}`]: {
          ...selectedRange,
          ...newSelection.range
        }
      });
      this.setState({
        focusedRange: newSelection.nextFocusRange,
        preview: null
      });
      onRangeFocusChange && onRangeFocusChange(newSelection.nextFocusRange);
    });
    _defineProperty(this, "handleRangeFocusChange", focusedRange => {
      this.setState({
        focusedRange
      });
      this.props.onRangeFocusChange && this.props.onRangeFocusChange(focusedRange);
    });
    _defineProperty(this, "updatePreview", val => {
      var _ranges$focusedRange$;
      if (!val) {
        this.setState({
          preview: null
        });
        return;
      }
      const {
        rangeColors,
        ranges
      } = this.props;
      const focusedRange = this.props.focusedRange || this.state.focusedRange;
      const color = ((_ranges$focusedRange$ = ranges[focusedRange[0]]) === null || _ranges$focusedRange$ === void 0 ? void 0 : _ranges$focusedRange$.color) || rangeColors[focusedRange[0]] || color;
      this.setState({
        preview: {
          ...val.range,
          color
        }
      });
    });
    this.state = {
      focusedRange: props.initialFocusedRange || [(0, _utils.findNextRangeIndex)(props.ranges), 0],
      preview: null
    };
    this.styles = (0, _utils.generateStyles)([_styles.default, props.classNames]);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_Calendar.default, _extends({
      YearArrowIconPrev: () => /*#__PURE__*/_react.default.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.788 5.77399C20.0774 5.47763 20.0717 5.00279 19.7754 4.7134C19.479 4.42401 19.0042 4.42966 18.7148 4.72602L12.1231 11.4764C11.8385 11.7678 11.8385 12.233 12.1231 12.5244L18.7148 19.2748C19.0042 19.5712 19.479 19.5768 19.7754 19.2874C20.0717 18.998 20.0774 18.5232 19.788 18.2268L13.7079 12.0004L19.788 5.77399ZM10.56 7.12431C10.8494 6.82796 10.8437 6.35312 10.5474 6.06373C10.251 5.77434 9.77616 5.77999 9.48677 6.07634L4.2134 11.4767C3.92887 11.7681 3.92887 12.2333 4.2134 12.5246L9.48677 17.925C9.77616 18.2213 10.251 18.227 10.5474 17.9376C10.8437 17.6482 10.8494 17.1734 10.56 16.877L5.79827 12.0007L10.56 7.12431Z",
        fill: "#8E96A4"
      })),
      YearArrowIconNext: () => /*#__PURE__*/_react.default.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.28659 4.72601C4.9972 4.42966 4.52236 4.42401 4.22601 4.71341C3.92966 5.0028 3.92401 5.47764 4.21341 5.77399L10.2909 11.9976L4.21341 18.2213C3.92401 18.5176 3.92966 18.9925 4.22601 19.2819C4.52236 19.5713 4.9972 19.5656 5.28659 19.2693L11.8757 12.5216C12.1603 12.2302 12.1603 11.765 11.8757 11.4736L5.28659 4.72601ZM14.5117 6.07546C14.2223 5.77911 13.7475 5.77347 13.4511 6.06286C13.1548 6.35225 13.1491 6.82709 13.4385 7.12344L18.1981 11.9976L13.4385 16.8717C13.1491 17.168 13.1548 17.6429 13.4511 17.9323C13.7475 18.2217 14.2223 18.216 14.5117 17.9197L19.783 12.5216C20.0675 12.2302 20.0675 11.765 19.783 11.4736L14.5117 6.07546Z",
        fill: "#8E96A4"
      })),
      MonthArrowIconPrev: () => /*#__PURE__*/_react.default.createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M15.2722 7.29267C15.5719 7.00675 15.5831 6.53201 15.2972 6.2323C15.0113 5.93259 14.5365 5.92142 14.2368 6.20734L8.7323 11.4586C8.58394 11.6001 8.5 11.7962 8.5 12.0013C8.5 12.2063 8.58394 12.4024 8.7323 12.5439L14.2368 17.7952C14.5365 18.0811 15.0113 18.07 15.2972 17.7703C15.5831 17.4706 15.5719 16.9958 15.2722 16.7099L10.3365 12.0013L15.2722 7.29267Z",
        fill: "#8E96A4"
      })),
      MonthArrowIconNext: () => /*#__PURE__*/_react.default.createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/_react.default.createElement("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M17.7678 14.2074C17.4682 13.9215 16.9934 13.9325 16.7074 14.2322C16.4215 14.5318 16.4325 15.0066 16.7322 15.2926L21.6653 20.0008L16.7322 24.709C16.4325 24.9949 16.4215 25.4697 16.7074 25.7693C16.9934 26.069 17.4682 26.08 17.7678 25.7941L23.2694 20.5433C23.4177 20.4018 23.5016 20.2057 23.5016 20.0008C23.5016 19.7958 23.4177 19.5997 23.2694 19.4582L17.7678 14.2074Z",
        fill: "#8E96A4"
      })),
      showDateDisplay: false,
      showYearArrow: true,
      showEachMonth: true,
      showMonthName: false,
      showMonthAndYearPickers: false,
      focusedRange: this.state.focusedRange,
      onRangeFocusChange: this.handleRangeFocusChange,
      preview: this.state.preview,
      onPreviewChange: value => {
        this.updatePreview(value ? this.calcNewSelection(value) : null);
      }
    }, this.props, {
      displayMode: "dateRange",
      className: (0, _clsx.default)(this.styles.dateRangeWrapper, this.props.className),
      onChange: this.setSelection,
      updateRange: val => this.setSelection(val, false),
      ref: target => {
        this.calendar = target;
      }
    }));
  }
}
DateRange.defaultProps = {
  classNames: {},
  ranges: [],
  moveRangeOnFirstSelection: false,
  retainEndDateOnFirstSelection: false,
  rangeColors: ['#3d91ff', '#3ecf8e', '#fed14c'],
  disabledDates: []
};
DateRange.propTypes = {
  ..._Calendar.default.propTypes,
  onChange: _propTypes.default.func,
  onRangeFocusChange: _propTypes.default.func,
  className: _propTypes.default.string,
  ranges: _propTypes.default.arrayOf(_DayCell.rangeShape),
  moveRangeOnFirstSelection: _propTypes.default.bool,
  retainEndDateOnFirstSelection: _propTypes.default.bool
};
var _default = exports.default = DateRange;